<template>
  <div style="overflow-x: hidden; overflow-y:auto; max-height: 800px;" v-html="cn"></div>

  <p style="display: flex; justify-content: flex-start; background-color: #E6E6FA; padding: 10px;">
    <input type="checkbox" :id="'chk_'+props.ppup.ppupSn"
           v-model="isTodayShow"
           @change="setTodayShow(props.ppup.ppupSn)">
    <label :for="'chk_'+props.ppup.ppupSn">
    <span class="box"></span>
    <span class="label-txt mg0">오늘 하루 이 창을 열지 않음</span></label>
  </p>
</template>

<script setup>
import {onMounted, defineProps, defineEmits, ref} from "vue";
import {getStore, getUtils} from "@/utils/import";

const {$cmmn} = getUtils();
const {$loading} = getStore()

const props = defineProps({
  ppup: {
    type: Object,
  },
});
const emits = defineEmits(['close']);

const cn = ref();

const isTodayShow = ref(false);
const setTodayShow = (ppupSn) => {
  setCookie(`ppupSn_${ppupSn}`, 'done', 1);
  btnClose_click();
}

const setCookie = (name, value, days) => {
  let todayDate = new Date();
  todayDate.setDate(todayDate.getDate() + days);
  document.cookie = name + "=" + escape(value) + "; path=/; expires=" + todayDate.toGMTString() + ";"
}

const btnClose_click = () => {
  emits('close');
};

const init = async () => {
  if (props.ppup?.cnImgFiles.length > 0) {
    const {setCn} = await $cmmn.txt.setCnImgSrc(props.ppup.ppupCn, props.ppup.cnImgFiles);
    cn.value = setCn;
  }
}

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
